module.exports = __webpack_public_path__ + "img/20190723144439QQ截图20190722221449.a252c40b.png";